/* eslint-disable */
import { I18n as I18nJS, TranslateOptions } from "i18n-js";
import translations from "./locales.json";

type FlattenObjectKeys<T extends Record<string, unknown>, Key = keyof T> = Key extends string
  ? T[Key] extends Record<string, unknown>
  ? `${Key}.${FlattenObjectKeys<T[Key]>}`
  : `${Key}`
  : never;
export type TranslationsObjectKeys = FlattenObjectKeys<(typeof translations)["ja"]>;
type StrictI18nJS = Omit<I18nJS, "t"> & {
  t: <T = string>(scope: TranslationsObjectKeys, options?: TranslateOptions) => string | T;
  translate: <T = string>(scope: TranslationsObjectKeys, options?: TranslateOptions) => string | T;
}
type PrefixedKeysImpl<T extends string, U extends string> = T extends `${U}${infer R}` ? R : never;
export type PrefixedKeys<T extends string> = PrefixedKeysImpl<TranslationsObjectKeys, T>;

const I18n = new I18nJS(translations) as StrictI18nJS;
if (typeof document !== 'undefined') {
  I18n.locale = document.querySelector('html')!.lang
}
export default I18n;
